


























import { Component, Vue } from 'vue-property-decorator';
import ApplicationListBase from '@/components/member/applicationList/ApplicationListBase.vue';

@Component({
  components: {
    ApplicationListBase,
  },
})
export default class ApplicantListDialog extends Vue {
  private isOpenApplicantListDialog: boolean = false;
  private OpenApplicantListDialog() {
    this.isOpenApplicantListDialog = !this.isOpenApplicantListDialog;
  }
  private closeApplicantListDialog() {
    this.isOpenApplicantListDialog = false;
  }
}
